/**
 * 返回url中参数
 */
export const getUrlParams = (() => {
  const path = window.location.href;
  let params = "";
  let res = {};
  return function() {
    if (!path.match(/\?/)) return {};
    params = path
      .split("?")[1]
      .split("#")[0]
      .split("&");
    if (JSON.stringify(res) === "{}") {
      res = params.reduce((obj, item) => {
        obj[item.split("=")[0]] = item.split("=")[1];
        return obj;
      }, {});
    }
    return res;
  };
})();
export const isLogin = () => {
  // eslint-disable-next-line
  return !!getAccount();
};

export const cookieUtil = () => {
  return {
    set: function(key, val, time = 1) {
      //设置cookie方法
      var date = new Date(); //获取当前时间
      var expiresDays = time; //将date设置为n天以后的时间
      date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000); //格式化为cookie识别的时间
      document.cookie = key + "=" + val + ";expires=" + date.toGMTString(); //设置cookie
    },
    get: function(key) {
      //获取cookie方法
      /*获取cookie参数*/
      console.log("document.cookie", document.cookie);

      var getCookie = document.cookie.replace(/[ ]/g, ""); //获取cookie，并且将获得的cookie格式化，去掉空格字符
      var arrCookie = getCookie.split(";"); //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
      var tips; //声明变量tips
      for (var i = 0; i < arrCookie.length; i++) {
        //使用for循环查找cookie中的tips变量
        var arr = arrCookie[i].split("="); //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
        if (key == arr[0]) {
          //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
          tips = arr[1]; //将cookie的值赋给变量tips
          break; //终止for循环遍历
        }
      }
      return tips;
    },
    delete: function(key) {
      var date = new Date(); //获取当前时间
      date.setTime(date.getTime() - 10000); //将date设置为过去的时间
      document.cookie = key + "=v; expires =" + date.toGMTString(); //设置cookie
    },
  };
};
/**
 * 
 * @param {
        fontFamily: '微软雅黑',
        fontColor: '#AAAAAA',
        lineHeight: 18,
        fontHeight: 16;
        word: '我是风我是风中一匹狼我是风中一',
        fontStyle: '200 16px 微软雅黑'
    } msg 
 */
export const word2Img = (msg) => {
  var c = document.createElement("canvas");
  c.height = 20;
  var ctx = c.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.globalAlpha = 0;
  c.height = 100;
  ctx.globalAlpha = 1;
  ctx.font = msg.fontStyle;
  ctx.fillStyle = msg.fontColor;
  ctx.fillText(msg.word, 0, msg.lineHeight + (1 / 2) * msg.fontHeight);
  // c.height=20;
  var width = ctx.measureText(msg.word).width;
  var height = msg.lineHeight + msg.fontHeight;
  var imgDataA = ctx.getImageData(0, 0, Math.round(width), Math.round(height));

  var d = document.createElement("canvas");
  var ctx2 = d.getContext("2d");
  d.height = height;
  d.width = width;
  ctx2.putImageData(imgDataA, 0, 0);
  return d.toDataURL();
};
/**
 * 判断监听dom
 * @param { HTMLElement } dom 传入的dom
 * @param { Number } distance 露出底部的距离
 * @param { Function } cb  回调函数
 */

export const judgeScrollDistance = (dom, cb, distance = 0) => {
  // 参数检测
  if (!(dom instanceof HTMLElement)) {
    return;
  }
  let oldDom = dom;
  // 实现逻辑
  while (dom && dom.scrollHeight <= dom.parentNode.scrollHeight) {
    dom = dom.parentNode;
  }
  // 此处可以改为hash 计算
  let varName = "func_" + Math.random();
  window[varName] = function() {
    let top = oldDom.offsetTop;
    let height = dom.clientHeight;
    let line = top - height + distance;
    if (dom.scrollTop > line) {
      cb();
      dom.removeEventListener("scroll", window[varName]);
    }
  };
  dom.addEventListener("scroll", window[varName]);
  window[varName]();
};

// 用户阅读字数统计  dom 第一个埋点发送时的字数  间隔字数
export const ReadCont = function(config) {
  this.config = {
    dom: "", //原生dom节点
    first: 450, // 首次发送埋点时的字数
    space: 140, // 埋点间隔
    cb: function() {},
  };
  this.config = Object.assign(this.config, config);
  if (!this.config.dom) {
    return false;
  }
  this.init();
};

ReadCont.prototype.init = function() {
  this.insertDom();
  this.bindEvent();
};
// 主逻辑 插入dom
ReadCont.prototype.insertDom = function() {
  let dom = this.config.dom.childNodes[0];
  let first = this.config.first;
  let space = this.config.space;
  let stack = [dom]; // 栈结构
  let arr = []; // 输出dom顺序
  while (stack.length > 0) {
    if (
      dom &&
      (dom.childNodes.length > 1 ||
        (dom.childNodes.length === 1 && dom.childNodes[0].nodeType != 3))
    ) {
      dom = dom.childNodes[0];
      stack.push(dom);
    } else {
      let transit = stack.pop();
      // 先找兄弟节点
      if (transit.nextSibling || stack.length === 0) {
        arr.push(dom);
        dom = transit.nextSibling;
        while (this.judegDom(dom)) {
          dom = dom.nextSibling;
        }
        if (dom) {
          stack.push(dom);
        }
      }
    }
  }
  // 添加dom
  let len = 0;
  let self = this;
  arr.forEach(function(ele) {
    if (!ele) return;
    // 判断当前的节点是否是符合规范的节点
    if (ele && ele.className && ele.className.indexOf("sp-robot") > -1) {
      return;
    }
    if (ele.nodeType == 3) {
      ele = self.replaceDom(ele);
    }
    let htmlStr = ele.innerText || "";
    let str = "";
    for (let index = 0; index < htmlStr.length; index++) {
      str += htmlStr[index];
      len++;
      if (len >= first && (len - first) % space === 0) {
        str += "<span class='statReadTag'>" + "</span>";
      }
    }
    ele.innerHTML = str;
  });
};
// 辅助函数 替换text节点为span节点 方便添加tag 返回替换后的dom
ReadCont.prototype.replaceDom = function(dom) {
  let parentNode = dom.parentNode;
  let newDom = document.createElement("span");
  newDom.innerHTML = dom.data;
  parentNode.replaceChild(newDom, dom);
  return newDom;
};
// 辅助函数  帮助判断标签值是否符合规范
ReadCont.prototype.judegDom = function(dom) {
  return (
    dom &&
    ((dom.nodeType != 3 &&
      dom.nodeType != 8 &&
      window.getComputedStyle(dom).display === "none") ||
      dom.tagName === "STYLE" ||
      dom.tagName === "SCRIPT")
  );
};
// 主逻辑 绑定滚动事件
ReadCont.prototype.bindEvent = function() {
  let mostHeight = 0;
  let statIndex = 0;
  let $readTag = document.getElementsByClassName("statReadTag");
  let dom = $readTag[0];
  if (!dom) return;
  let cb = this.config.cb;
  while (dom && dom.scrollHeight <= dom.parentNode.scrollHeight) {
    dom = dom.parentNode;
  }
  dom.removeEventListener("scroll", eventFunc);
  let eventFunc = function() {
    if (statIndex == $readTag.length) {
      return;
    }
    let clientHeight = dom.clientHeight;
    let scrollTop = dom.scrollTop;
    let height = clientHeight + scrollTop;
    if (height > mostHeight) {
      mostHeight = height;
      if (
        statIndex < $readTag.length &&
        mostHeight > $readTag[statIndex].offsetTop
      ) {
        cb(statIndex + 1);
        statIndex++;
      }
    }
  };
  dom.addEventListener("scroll", eventFunc);
};
